import React, {useEffect, useRef, useState} from 'react';
import JellyCheckBox from "../search/JellyCheckBox";

/**
 * `필터 `테이블필터
 * 테이블 헤더 필터
 * setFilterOpen : 이 컴포넌트의 외부를 클릭하면 이 컴포넌트가 닫힌다
 * data : 테이블의 헤더 정보를 받아서 체크여부에 따라 보여줄 헤더를 반환한다.
 * data.data : 전체 테이블 헤더
 * data.th : 실제 테이블에서 표시해줄 헤더
 * data.fnc : 보여줄 헤더를 제어해주는 메서드
 * */

function FilterBasic({data, setFilterOpen}) {

    const wrapperRef = useRef(null);
    //현재 활성화 된 헤더에 체크표시를 해준다 checkedItems => 체크표시 되어야할 요소들 배열
    // ex [assetName:true, assetCode:false ...] 이렇게 배열에 담고 실체 체크박스에서는 checkedItems[header.name] 가 true, false 에 따라 체크 활성, 비활성화
    const [checkedItems, setCheckedItems] = useState(
        data.th.reduce((acc, item) => {
            acc[item.name] = true;
            return acc;
        }, {})
    );

    // 체크박스 변경 핸들러
    const handleCheckboxChange = (fieldName) => {

        setCheckedItems((prevCheckedItems) => {
    /***현재 화면의 체크 활성, 비활성을 제어하는 부분***/
            const updatedCheckedItems = {
                ...prevCheckedItems,
                [fieldName]: !prevCheckedItems[fieldName],
            };
            
            const checkedFields = Object.keys(updatedCheckedItems).filter(
                (name) => updatedCheckedItems[name]
            );

    /***부모화면의 테이블 헤더를 제어하는 부분 ***/
            // 체크가 해제된 경우, data.th에서 해당 요소 제거
                // => 테이블에서 안보임
            if (!updatedCheckedItems[fieldName]) {
                const indexToRemove = data.th.findIndex((item) => item.name === fieldName);
                if (indexToRemove !== -1) {
                    const updatedTh = [...data.th];
                    updatedTh.splice(indexToRemove, 1);
                    data.fnc(updatedTh);
                }
                
            // 체그된 경우 data.th 기존 data.data 순서대로 넣기 위해 checkedItems 에서 true(현제 체크 활성화 된 요소들) data.data 에서 요소를 모아서 그대로 다시 셋해줌
                // => 테이블에서 다시 나타남
            } else {
                const itemsToAdd = data.data
                    .filter((each) => checkedFields.includes(each.name))
                    .map((each) => (each));

                /*
                * todo
                * 테이블헤더를 제거했다가 다시 추가할때 렌더링 에러남. 사용상 문제는 없는데 추후 리팩토링 할 수 있으면 하는게 좋을 듯
                * **/
                data.fnc(itemsToAdd);
            }

            return updatedCheckedItems;
        });
    };


    useEffect(() => {
        // 컴포넌트가 마운트될 때 이벤트 리스너를 추가
        document.addEventListener('mousedown', handleClickOutside);
        // 컴포넌트가 언마운트될 때 이벤트 리스너를 제거
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // 바깥 영역을 클릭시 닫기
    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setFilterOpen(false);
        }
    };

    return (
        <div className="th-filter"  ref={wrapperRef}>
            <ul>
            {data.data.map((each,index)=>(
                <li className={"table-filter-list"} key={index}>
                    <JellyCheckBox
                        className={"table-filter-chkbox"}
                        title={each.name}
                        checked={checkedItems[each.name]}
                        fnc={()=>handleCheckboxChange(each.name)}
                        each={each}
                    />
                </li>
            ))}
            </ul>
        </div>
    );
}

export default FilterBasic;